import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import StickyToolbar from "../../../../../Components/StickyToolbar";
import { faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FormProvider, useForm } from "react-hook-form";
import { ILstParcelasParaPositivacaoBody } from "../../../../../Interfaces/Cobranca/Serasa/Positivar";
import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import { ListarEmpreendimentosController } from "../../../../../Controllers/Geral/Produtos/ProdutosControllers";
import Select from "react-select";

interface IFiltroPositivar {
    filter: ILstParcelasParaPositivacaoBody | undefined;
    FILTRO_GESTAO_A_POSITIVAR: ILstParcelasParaPositivacaoBody | undefined;
    handleDateChange: (formData: ILstParcelasParaPositivacaoBody) => void;
    setIdEmpreendimento: Dispatch<SetStateAction<string | number[]>>;
    filtroInicial: {
        DT_POSITIVACAO: string;
        DT_NEGATIVACAO: string;
        DS_STATUS: string;
        DS_USUARIO: string;
        DS_CLIENTE?: string;
        ID_EMPREENDIMENTO?: string | number | number[] | Array<{}> | null;
        NR_CPF_CNPJ: string;
        DS_TIPO_CLIENTE: string;
        NR_VENDA: string;
    };
    setFilter: (filter: ILstParcelasParaPositivacaoBody) => void;
    setLimparFiltros: Dispatch<SetStateAction<boolean>>;
    setPage: (page: number) => void;
}

export default function FiltroPositivar(props: IFiltroPositivar) {
    const FormMethods = useForm();
    const [options, setOptions] = useState<
        Array<{ value: number; label: string }> | undefined
    >();
    const { register, handleSubmit, reset } = FormMethods;
    const idEmpreendimentoRef = useRef<any>();

    const limparFiltros = () => {
        idEmpreendimentoRef.current?.clearValue();
    };
    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
            border: "1px solid #e4e6ef",
            transition:
                "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        }),
    };

    const { value: listarEmpreendimentos } = useAsyncEffect(
        () => ListarEmpreendimentosController(),
        []
    );

    useEffect(() => {
        setOptions(() =>
            listarEmpreendimentos?.map((empreendimento) => ({
                label: empreendimento.DS_EMPREENDIMENTO,
                value: empreendimento.ID_EMPREENDIMENTO,
            }))
        );
    }, [listarEmpreendimentos]);
    return (
        <>
            <StickyToolbar active={!!props.FILTRO_GESTAO_A_POSITIVAR}>
                <FormProvider {...FormMethods}>
                    <form
                        className="form-group row"
                        onSubmit={handleSubmit(props.handleDateChange)}
                    >
                        <div className="col-12 mt-3">
                            <label>Data Negativação</label>
                            <input
                                className="form-control"
                                name="DT_NEGATIVACAO"
                                defaultValue={props.filter?.DT_NEGATIVACAO}
                                ref={register()}
                                type="date"
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Data Positivação</label>
                            <input
                                className="form-control"
                                name="DT_POSITIVACAO"
                                defaultValue={props.filter?.DT_POSITIVACAO}
                                ref={register()}
                                type="date"
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Cliente</label>
                            <input
                                name="DS_USUARIO"
                                className="form-control"
                                type={"text"}
                                ref={register()}
                                defaultValue={props.filter?.DS_USUARIO}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Empreendimento</label>
                            <Select
                                name="ID_EMPREENDIMENTO"
                                ref={idEmpreendimentoRef}
                                options={options}
                                isClearable
                                isMulti
                                onChange={(e) => {
                                    props.setIdEmpreendimento(
                                        e.map((value) => value?.value)
                                    );
                                }}
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                }}
                                styles={customStyles}
                                placeholder={""}
                                noOptionsMessage={() => "Nenhuma opção"}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>CPF/CNPJ</label>
                            <input
                                className="form-control"
                                type={"text"}
                                name="NR_CPF_CNPJ"
                                ref={register()}
                                defaultValue={props.filter?.NR_CPF_CNPJ}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Número da Venda</label>
                            <input
                                className="form-control"
                                name="NR_VENDA"
                                ref={register()}
                                defaultValue={props.filter?.NR_VENDA}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Tipo Cliente</label>
                            <select
                                className="form-control"
                                name="DS_TIPO_CLIENTE"
                                ref={register()}
                                defaultValue={props.filter?.DS_TIPO_CLIENTE}
                            >
                                <option></option>
                                <option>Cliente</option>
                                <option>Fiador</option>
                                <option>Co-comprador</option>
                            </select>
                        </div>
                        <div className="col-12 mt-3">
                            <label>Status da Parcela</label>
                            <select
                                className="form-control"
                                name="DS_STATUS"
                                defaultValue={props.filter?.DS_STATUS}
                                ref={register()}
                            >
                                <option></option>
                                <option>Em Fila</option>
                                <option>Positivado</option>
                                <option>A Positivar</option>
                                <option>Aguardando Positivação</option>
                            </select>
                        </div>

                        <div className="col-12 col-md-12 d-flex align-items-end justify-content-start mt-3">
                            <button
                                type="submit"
                                className="btn btn-block btn-outline-dark mt-2"
                            >
                                <FontAwesomeIcon
                                    icon={faFilter}
                                    className="mr-2"
                                />
                                Filtrar
                            </button>
                        </div>
                        <div className="col-12 d-flex align-items-end justify-content-start">
                            <button
                                type="button"
                                onClick={() => {
                                    window.sessionStorage.removeItem(
                                        "FILTRO_GESTAO_A_POSITIVAR"
                                    );
                                    limparFiltros();
                                    props.setFilter(props.filtroInicial);
                                    reset(props.filtroInicial);
                                    props.setLimparFiltros(true);
                                    props.setPage(1);
                                }}
                                className="btn btn-block btn-outline-danger mt-2"
                            >
                                <FontAwesomeIcon
                                    icon={faTimes}
                                    className="mr-2"
                                />
                                Limpar Filtros
                            </button>
                        </div>
                    </form>
                </FormProvider>
            </StickyToolbar>
        </>
    );
}
